import { render } from "./HeaderSection.vue?vue&type=template&id=56e9b524"
import script from "./HeaderSection.vue?vue&type=script&lang=js"
export * from "./HeaderSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__